import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { getResources, registerDownload } from "@/lib/api";
import Seo from "@/components/Seo";

export default function Recursos() {
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getResources().then(setResources).finally(() => setLoading(false));
  }, []);

  const download = (r, url) => {
    if (!url) return toast.info("Este recurso estará disponible próximamente.");
    registerDownload(r.id).catch(() => {});
    window.open(url, "_blank");
  };
  const btnCls = "inline-flex items-center justify-center gap-2 rounded-full bg-[#1f44e0] px-5 py-2.5 text-xs font-semibold tracking-[0.1em] text-white hover:bg-[#0f2544] transition-colors";
  const options = (r) => [
    r.archivo_pdf && { k: "pdf", label: "DESCARGAR PDF", url: r.archivo_pdf },
    r.archivo_epub && { k: "epub", label: "DESCARGAR EPUB", url: r.archivo_epub },
    r.archivo && { k: "link", label: r.archivo_pdf || r.archivo_epub ? "ENLACE EXTERNO" : "DESCARGAR GRATIS", url: r.archivo },
  ].filter(Boolean);

  return (
    <>
      <Seo title="Descargas gratuitas" description="Libros y materiales de descarga gratuita de Editorial Harvest." />
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 pt-16 pb-8 text-center">
        <p className="hv-overline">Gratis</p>
        <h1 className="font-serif text-4xl md:text-5xl text-[#0f2544] mt-3">Descargas gratuitas</h1>
        <p className="text-[#4a4a45] mt-4 max-w-2xl mx-auto">
          Ponemos a disposición de nuestros lectores una selección de libros y recursos que pueden
          descargarse gratuitamente para uso personal.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-10" data-testid="resources-grid">
        {loading ? (
          <p className="text-center text-[#8a8a83]">Cargando...</p>
        ) : resources.length === 0 ? (
          <div className="rounded-lg border border-dashed border-[#0f2544]/15 bg-[#eceae4] py-20 text-center">
            <p className="text-[#8a8a83]">Nuevos recursos gratuitos estarán disponibles próximamente.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {resources.map((r) => (
              <div key={r.id} className="flex flex-col" data-testid={`resource-${r.slug}`}>
                <div className="hv-book">
                  {r.portada ? <img src={r.portada} alt={r.titulo} /> : <div className="w-full h-full bg-[#e2e0da]" />}
                </div>
                <h3 className="font-serif text-lg font-semibold mt-4 text-[#0f2544]">{r.titulo}</h3>
                {r.autor && <p className="text-sm text-[#8a8a83]">{r.autor}</p>}
                {r.descripcion && <p className="text-sm text-[#4a4a45] mt-2 leading-relaxed line-clamp-3">{r.descripcion}</p>}
                <div className="mt-4 flex flex-col gap-2">
                  {options(r).length === 0 ? (
                    <button onClick={() => download(r, "")} className={btnCls} data-testid={`resource-download-${r.slug}`}><Download size={14} /> DESCARGAR GRATIS</button>
                  ) : options(r).map((o) => (
                    <button key={o.k} onClick={() => download(r, o.url)} className={btnCls} data-testid={`resource-download-${o.k}-${r.slug}`}>
                      <Download size={14} /> {o.label}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 pb-16">
        <div className="rounded-lg bg-[#eceae4] border border-[#0f2544]/10 p-6 text-sm text-[#8a8a83] leading-relaxed">
          Los materiales disponibles en esta sección se ofrecen exclusivamente bajo las condiciones de uso
          indicadas para cada obra. Su disponibilidad gratuita no implica renuncia a los derechos de
          propiedad intelectual correspondientes.
        </div>
      </section>
    </>
  );
}
